export const DOCK_APP_STATE_RECEIVED = "DOCK_APP_STATE_RECEIVED";
export const CAMERAS_RECEIVED = "CAMERAS_RECEIVED";
export const CAMERA_DOCKED = "CAMERA_DOCKED";
export const REMOVE_DOCKED_CAMERA = "REMOVE_DOCKED_CAMERA";
export const TOGGLE_FIND_NEAREST = "TOGGLE_FIND_NEAREST";
export const CLEAR_FIND_NEAREST = "CLEAR_FIND_NEAREST";
export const CLEAR_CAMERA_REPLACE_MODE = "CLEAR_CAMERA_REPLACE_MODE";
export const CAMERA_TO_DOCK_MODE = "CAMERA_TO_DOCK_MODE";
export const CAMERA_PRIORITY_SET = "CAMERA_PRIORITY_SET";
